import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 18H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 18V8a2 2 0 0 0-2-2h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 8-2-2 2-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListStart";
const ListStart = memo(themed(Icon));
export {
  ListStart
};
//# sourceMappingURL=list-start.js.map
